import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const CoverageSpecifics = lazy(
  () => import('@pages/landing/CoverageSpecifics'),
);

export const CoverageSpecificsRoutes: RouteObject[] = [
  {
    path: '/coverage-specifics',
    element: (
      <React.Suspense>
        <CoverageSpecifics />
      </React.Suspense>
    ),
  },
];
